export default "__VITE_ASSET__D_KoyR8B__"